module.exports = __webpack_public_path__ + "static/img/main_ip.215da498.png";